/* eslint-disable */
import * as util from "@/api/messageReport";

const state = {};


const mutations = {
};

const actions = {
    broadcastStopMessage({ commit }, params) {
        return new Promise((resolve, reject) => {
            util.broadcastStopMessage(params).then(response => {
                resolve(response);
            }).catch(error => {
                reject(error);
            });
        });
    },
    broadcastDeleteMessage({ commit }, params) {
        return new Promise((resolve, reject) => {
            util.broadcastDeleteMessage(params).then(response => {
                resolve(response);
            }).catch(error => {
                reject(error);
            });
        });
    },
    broadcastDraftMessage({ commit }, params) {
        return new Promise((resolve, reject) => {
            util.broadcastDraftMessage(params).then(response => {
                resolve(response);
            }).catch(error => {
                reject(error);
            });
        });
    },
    listBroadcastV2({ commit }, params) {
        return new Promise((resolve, reject) => {
            util.listBroadcastV2(params).then(response => {
                resolve(response);
            }).catch(error => {
                reject(error);
            });
        });
    },
    broadcastMonitoring({ commit }, params) {
        return new Promise((resolve, reject) => {
            util.broadcastMonitoring(params).then(response => {
                resolve(response);
            }).catch(error => {
                reject(error);
            });
        });
    },
    listSmartReplyDetailMonthly({ commit }, params) {
        return new Promise((resolve, reject) => {
            util.listSmartReplyDetailMonthly(params).then(response => {
                resolve(response);
            }).catch(error => {
                reject(error);
            });
        });
    },
    listSmartReplysMonthly({ commit }, params) {
        return new Promise((resolve, reject) => {
            util.listSmartReplysMonthly(params).then(response => {
                resolve(response);
            }).catch(error => {
                reject(error);
            });
        });
    },
    listSmartReplysMonthlyExcel({ commit }, params) {
        return new Promise((resolve, reject) => {
            util.listSmartReplysMonthlyExcel(params).then(response => {
                resolve(response);
            }).catch(error => {
                reject(error);
            });
        });
    },
    listButtonsDetailMonthly({ commit }, params) {
        return new Promise((resolve, reject) => {
            util.listButtonsDetailMonthly(params).then(response => {
                resolve(response);
            }).catch(error => {
                reject(error);
            });
        });
    },
    listButtonsMonthly({ commit }, params) {
        return new Promise((resolve, reject) => {
            util.listButtonsMonthly(params).then(response => {
                resolve(response);
            }).catch(error => {
                reject(error);
            });
        });
    },
    listButtonsMonthlyExcel({ commit }, params) {
        return new Promise((resolve, reject) => {
            util.listButtonsMonthlyExcel(params).then(response => {
                resolve(response);
            }).catch(error => {
                reject(error);
            });
        });
    },
    listBroadcast({ commit }, params) {
        return new Promise((resolve, reject) => {
            util.listBroadcast(params).then(response => {
                resolve(response);
            }).catch(error => {
                reject(error);
            });
        });
    },
    listMessage({ commit }, params) {
        return new Promise((resolve, reject) => {
            util.listMessage(params).then(response => {
                resolve(response);
            }).catch(error => {
                reject(error);
            });
        });
    },
    listMessageExcel({ commit }, params) {
        return new Promise((resolve, reject) => {
            util.listMessageExcel(params).then(response => {
                resolve(response);
            }).catch(error => {
                reject(error);
            });
        });
    },
    listBroadcastPrepare({ commit }, params) {
        return new Promise((resolve, reject) => {
            util.listBroadcastPrepare(params).then(response => {
                resolve(response);
            }).catch(error => {
                reject(error);
            });
        });
    },
    listBroadcastImport({ commit }, params) {
        return new Promise((resolve, reject) => {
            util.listBroadcastImport(params).then(response => {
                resolve(response);
            }).catch(error => {
                reject(error);
            });
        });
    },
};


export default {
    namespaced: true,
    state,
    mutations,
    actions
};



// WEBPACK FOOTER //
// ./src/store/modules/messageReport.js